<template>
  <tbody>
    <tr v-for="(lot, i) in rows" :key="i">
      <td class="text-center white-space-nowrap">
        {{ lot.name }}
      </td>
      <td class="text-center white-space-nowrap">
        {{ coveredAreas[lot.numberLot] }}
      </td>
      <template v-for="(ribbon, week) in columns">
        <td class="text-center">
          {{ getFormatNumber(getNumberClusters(week, lot.numberLot)) }}
        </td>
        <td class="text-center">
          {{
            getFormatNumber(getNumberClusters(week, lot.numberLot, 'byLotsHa'))
          }}
        </td>
        <td class="text-center">
          {{ getPercent(week, lot.numberLot, ribbon) }}
        </td>
      </template>
    </tr>
  </tbody>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import MixinMasters from 'src/util/mixinMasters';
import Formatter from 'src/class/Formatter';

export default {
  name: 'tbody-percente-pockets',
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    coveredAreas: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    data: {
      type: Array | Object,
      default: [],
    },
    totalColumns: {
      type: Array | Object,
      default: [],
    },
  },
  mixins: [MixinMasters],
  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(value);
    },
    getNumberClusters(week, lot, option = '') {
      try {
        return getSumOfValorFromArray(
          this.data[week][lot].map((data) => {
            if (option === 'byLotsHa') {
              return Number(data.covered_area) > 0
                ? data.number_clusters / data.covered_area
                : '';
            }
            return data.number_clusters;
          })
        );
      } catch (error) {
        return '';
      }
    },
    getTotalColumn(week, ribbon) {
      const result = Object.values(
        this.totalColumns[week][ribbon.color_name]
      ).map((totalColumn) =>
        Array.isArray(totalColumn)
          ? getSumOfValorFromArray(totalColumn)
          : totalColumn
      );

      return getSumOfValorFromArray(result);
    },
    getPercent(week, lot, ribbon) {
      try {
        const percent =
          this.getNumberClusters(week, lot) /
          this.getTotalColumn(week, ribbon[0]);
        return `${Formatter.formatNumber(percent * 100)}%`;
      } catch (error) {
        return '';
      }
    },
  },
};
</script>
